<template>
  <ValidationProvider :vid="vid"
                      :mode="mode"
                      :rules="rules"
                      :name="$attrs.label"
                      v-slot="{ errors, valid }">
    <v-checkbox
      v-model="innerValue"
      :error-messages="errors"
      :success="valid"
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :type="type"
      :color="color" />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    // must be included in props
    value: {
      type: null,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    vid: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
